function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 61 40"
}, props), React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M60.75 35c0 2.75-2.25 5-5 5h-50c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h50c2.75 0 5 2.25 5 5v30z",
  fill: "#A2CFB5"
}), React.createElement("path", {
  fill: "#7AAC8F",
  d: "M2 7h58v7H2z"
}), React.createElement("path", {
  d: "M59.28 1.47A4.985 4.985 0 0160.75 5v30a4.98 4.98 0 01-1.47 3.53A4.987 4.987 0 0155.75 40h-50a4.98 4.98 0 01-3.53-1.47L59.28 1.47z",
  fill: "#FFF",
  opacity: ".06"
}), React.createElement("path", {
  d: "M55.75 1c2.206 0 4 1.794 4 4v30c0 2.206-1.794 4-4 4h-50c-2.206 0-4-1.794-4-4V5c0-2.206 1.794-4 4-4h50zm0-1h-50C3 0 .75 2.25.75 5v30c0 2.75 2.25 5 5 5h50c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5z",
  fill: "#F8F8F9"
}))));